import React, { Fragment } from 'react';
import { add as addToCartService } from '../Services/Cart.service';
import withReactiveStyleBuyButton from '../Components/withReactiveStyleBuyButton';
import { receive, loadError } from '../Actions/Cart.action';
import { catchError } from '../Actions/Error.action';
import { useDispatch } from 'react-redux';

const BuyButton = ({
    label,
    articleNumber,
    multiple,
    quantityFieldId,
    href,
    cssClass,
    onClick,
}) => {
    const isPackageModal = false;
    return (
        <Fragment>
            {articleNumber ? (
                <a
                    className={
                        isPackageModal ? 'buy-button button product-detail__buy-button' : cssClass
                    }
                    onClick={(e) => {
                        e.preventDefault();
                        onClick({ articleNumber, quantityFieldId, multiple });
                    }}
                    href={href || '#'}
                    rel="nofollow"
                >
                    {!isPackageModal ? (
                        cssClass.indexOf('product-detail__buy-button') === -1 ? (
                            <span
                                title={label}
                                className="product-list__buy-button-icon buy-button"
                            ></span>
                        ) : (
                            <Fragment>{label}</Fragment>
                        )
                    ) : (
                        <Fragment>{label}</Fragment>
                    )}
                </a>
            ) : (
                <a className={cssClass} href={href}>
                    {cssClass.indexOf('product-detail__buy-button') === -1 ? (
                        <span title={label} className="product-list__buy-button-show-icon"></span>
                    ) : (
                        <Fragment>{label}</Fragment>
                    )}
                </a>
            )}
        </Fragment>
    );
};

const StyledButton = (props) => {
    const dispatch = useDispatch();
    const onClick = async ({ articleNumber, quantityFieldId, multiple }) => {
        try {
            const quantity = quantityFieldId ? document.getElementById(quantityFieldId).value : multiple;
            const cart = await addToCartService({ articleNumber, quantity });
            if (cart.dataLayer && typeof dataLayer !== 'undefined' && dataLayer !== null) {
                gtag("event",cart.event,cart.dataLayer);
            }
            dispatch(receive(cart));

            const catnav = document.querySelector('.js-product__category');
            if (catnav && window.__litium.requestContext.productCategorySystemId) {
                fetch('/api/klevu/catnav?cat=' + window.__litium.requestContext.productCategorySystemId + "&v=" + articleNumber, {
                    method: 'GET',
                    headers: {
                        'pragma': 'no-cache',
                        'cache-control': 'no-cache',
                        'litium-request-context': JSON.stringify(
                            window.__litium.requestContext
                        )
                    }
                });
            }
            const query = document.querySelector('.query');
            if (query){
                fetch('/api/klevu/quicksearch?v=' + articleNumber + "&q=" + encodeURIComponent(query.innerHTML), {
                    method: 'GET',
                    headers: {
                        'pragma': 'no-cache',
                        'cache-control': 'no-cache',
                        'litium-request-context': JSON.stringify(
                            window.__litium.requestContext
                        )
                    }
                });
            }

            return true;
        } catch (ex) {
            dispatch(catchError(ex, (error) => loadError(error)));
            return false;
        }
    };
    const Button = withReactiveStyleBuyButton(BuyButton, onClick, 'buy-button');
    return <Button {...props} />;
};

export default StyledButton;
